import { render, staticRenderFns } from "./FormMultiplesChoices.vue?vue&type=template&id=0b8e6999&scoped=true"
import script from "./FormMultiplesChoices.vue?vue&type=script&lang=js"
export * from "./FormMultiplesChoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8e6999",
  null
  
)

export default component.exports